export class Lector
{
    buttonsPlay = document.querySelectorAll('[data-s~="Lector:play"]')
	buttonsStop = document.querySelectorAll('[data-s~="Lector:stop"]')
	welcome = document.querySelector('[data-s~="Lector:welcome"]')
	buttonsHide = document.querySelectorAll('[data-s~="Lector:welcome:hide"]')

    text = null
    lang = "pl-PL"
    pitch = 1
    volume = 1
    rate = 1

    constructor(store)
    {
        this.store = store
        this.run()
    }

    run()
    {
        this.Utterance = new SpeechSynthesisUtterance()
        this.Synthesis = window.speechSynthesis

        this.Utterance.lang = this.lang
        this.Utterance.pitch = this.pitch
        this.Utterance.volume = this.volume
        this.Utterance.rate = this.rate

        this.availableVoices = null
        this.availableSpeaking = false

        const voicesList = new Promise(resolve => {
            let voices = speechSynthesis.getVoices()
            if (voices.length) {
                resolve(voices)
                return
            }
            speechSynthesis.onvoiceschanged = () => {
                voices = speechSynthesis.getVoices()
                resolve(voices)
            }
        })

        voicesList.then(result => {
            result.forEach(voice => {
                this.availableVoices += voice.lang
            })
            if (this.availableVoices.includes(this.store.config.lang)) {
                this.availableSpeaking = true
            } else {
                this.availableSpeaking = false
            }
        })
    }

    speak()
    {
        this.quiet()

        if (this.availableSpeaking) {
            this.Utterance.text = this.text
            this.Synthesis.speak(this.Utterance)
        } else {
            this.store.service.Modal.target = "lector"
            this.store.service.Modal.show()
        }
    }

    quiet()
    {
        this.Synthesis.cancel()
    }

    reset()
    {
        this.buttonsPlay.forEach(e => {
			e.style.display = null
		})
        this.buttonsStop.forEach(e => {
			e.style.display = null
		})
    }

    show()
    {
        this.welcome.style.display = "flex"

        setTimeout(() => {
            this.welcome.style.opacity = "1"
            this.welcome.style.transform = "translateY(0)"
            this.welcome.style.pointerEvents = "all"
        }, 100)
    }

    hide()
    {
		this.welcome.style.opacity = null
		this.welcome.style.transform = null
		this.welcome.style.pointerEvents = null

		setTimeout(() => {
			this.welcome.style.display = null
		}, 250)
    }

    play(e)
    {
        if (this.availableSpeaking) {
            this.reset()

            let uuid = e.getAttribute("data-uuid")
            let texts = document.querySelectorAll('[data-s~="Lector:text"][data-uuid~="'+uuid+'"]')

            let text = ""

            if (uuid == "f5e14738-95f4-48e0-ac8f-b3cb40d9aefa") {
                this.show()
            } else {
                this.hide()
            }

            texts.forEach(e => {
                text += e.textContent + ". "
            })

            this.text = text

            this.speak()

            let buttonStop = document.querySelector('[data-s~="Lector:stop"][data-uuid~="'+uuid+'"]')

            e.style.display = "none"
            buttonStop.style.display = "flex"
        } else {
            this.store.service.Modal.target = "lector"
            this.store.service.Modal.show()
        }
    }

    stop()
    {
        this.reset()
        this.quiet()
        this.hide()
    }

    watch()
    {
        this.buttonsHide.forEach(e => {
			e.addEventListener("click", () => {
                this.reset()
                this.quiet()
                this.hide()
			})
		})
        this.buttonsPlay.forEach(e => {
            e.addEventListener("click", () => {
                this.play(e)
            })
		})
		this.buttonsStop.forEach(e => {
			e.addEventListener("click", () => {
				this.stop()
			})
		})
        window.addEventListener("load", () => {
            this.quiet()
        })
        window.addEventListener("unload", () => {
            this.quiet()
        })
        this.Utterance.addEventListener("end", () => {
            this.reset()
            this.quiet()
            this.hide()
        })
    }
}
